const getLocalStorageInt = ({ key }) => {
  const string = localStorage.getItem(key);
  if (string) {
    const parsed = parseInt(string, 10);
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};
export {
  getLocalStorageInt
};
//# sourceMappingURL=getLocalStorageInt.js.map
